import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import {
  ProductDetailResponse,
  ProductStore,
} from 'src/app/stores/product.store';
import { imageUrl, ProductCondition } from 'src/environments/environment';
import { ProductImageModalComponent } from '../product-image-modal/product-image-modal.component';
import { images } from 'src/app/stores/checkout.store';
import { VideoModalComponent } from '../video-modal/video-modal.component';

@Component({
  selector: 'app-product-slider',
  templateUrl: './product-slider.component.html',
  styleUrls: ['./product-slider.component.scss'],
})
export class ProductSliderComponent implements OnInit {
  @Input() productDetail: ProductDetailResponse;
  @Input() index: any;

  imageUrl = imageUrl;
  productCondition = ProductCondition;
  constructor(
    private modalCtrl: ModalController,
    public platform: Platform,
    private productStore: ProductStore
  ) {
    this.productStore?.activeIndex?.subscribe((resp) => {
      // this.slides?.slideTo(resp);
    });
  }

  ngOnInit() {}

  async openPopup(value, type: number = null, slidesdata) {
    if (type === 1) {
      const modal = await this.modalCtrl.create({
        component: VideoModalComponent,
        cssClass: 'open-image',
        componentProps: {
          video: slidesdata,
          editOption: false,
        },
      });
      modal.present();
    } else {
      const modal = await this.modalCtrl.create({
        component: ProductImageModalComponent,
        cssClass: this.platform.is('mobile') ? 'open-image' : 'full-image',
        componentProps: {
          image: value,
        },
      });
      modal.present();
    }
  }
  showImage(event, product) {
    event?.stopPropagation();
    product.data.product.target_audience = 0;
  }
}
